import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement('canvas');
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 1, 2, 1);

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(0xffffff),
                emissive: new THREE.Color(0.20969663085937498, 0.21999999999999997, 0.21999999999999997),
                metalness: .01,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: .572,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: .34, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: false,
            });
        },
    },
    {
        materialName: "WallLightGlass",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `WallLightGlass-MPM`,
                color: new THREE.Color(0xffffff),
                //emissive :new THREE.Color( 0.20969663085937498, 0.21999999999999997, 0.21999999999999997 ),
                metalness: .001,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: 7,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: 0.5, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: false,
            });
        },
    },
    {
        materialName: "I_UV_01_V2.001",

        toneMapped: 'N',

    },
    {
        materialName: "I_UV_07_V2",
        toneMapped: 'N',
    },
    {
        materialName: "I_UV_02_V2",
        toneMapped: 'N',
    },
    {
        materialName: "I_UV_03_V2",
        toneMapped: 'N',
    },
    {
        materialName: "I_UV_04_V2",
        toneMapped: 'N',
    },
    {
        materialName: "I_UV_05_V2",
        toneMapped: 'N',
    },
    {
        materialName: "I_UV_06_V2",
        toneMapped: 'N',
    },
    {
        materialName: "G07F11AP27_mat",

        envMapIntensity: .001,
        toneMapped: 'N',
    },

    {
        materialName: "FloorMat",
        aOIntensity: 1.4761459307764264,
        emmisiveColor:
            new Color(0, 0, 0),
        emmissiveIntensity: 1.1808165357020841,
        envMapIntensity: 0.8700574108514596,
        lightMapIntensity: 1.5963443799111718,
        roughness: 0.5313460881448582,
        metalness: 1,
        toneMapped: 'N',
        color:
            new Color(1, 1, 1),
    },


    {
        materialName: "DoorsMat",
        aOIntensity: 1.0117089080959614,

        envMapIntensity: 1.2430383295271628,

        toneMapped: 'N',

    },

    {
        materialName: "DoorsFrameMat",
        aOIntensity: 0.6604582314388885,
        emmisiveColor:
            new Color(0.39, 0.34519147135416667, 0.24335390625000003),
        emmissiveIntensity: 1,
        envMapIntensity: 0.8700574108514596,
        lightMapIntensity: 1,
        roughness: 1,
        metalness: 1,
        toneMapped: 'Y',
        color:
            new Color(1, 1, 1),
    },




    {
        materialName: "WallBaseMat",
        aOIntensity: .001,

        envMapIntensity: 0.8700574108514596,

        toneMapped: 'N',

    },


    {
        materialName:"CovingMat",
        aOIntensity:0.6285263517427909,
        emmisiveColor:
            new Color( 0.36, 0.33653031123991933, 0.23873994140625 ),
        emmissiveIntensity:1,
        envMapIntensity:2,
        lightMapIntensity:1,
        roughness:1,
        metalness:1,
        toneMapped:'Y',
        color:
            new Color( 1, 1, 1 ),
    },


    {
        materialName: "SpotLightGlassMat",

        toneMapped: 'N',

    },

    {
        materialName: "BenchMat",
        aOIntensity: 0.7577174929840973,
        emmisiveColor:
            new Color(0, 0, 0),
        emmissiveIntensity: 1,
        envMapIntensity: 1.1584318394421294,
        lightMapIntensity: 1,
        roughness: 1,
        metalness: 1,
        toneMapped: 'Y',
        color:
            new Color(1, 1, 1),
    },


    {
        materialName: "SkirtingTop",
        aOIntensity: 1.0436407877920588,
        emmisiveColor:
            new Color(0, 0, 0),
        emmissiveIntensity: 1,
        envMapIntensity: 0.9,
        lightMapIntensity: 1,
        roughness: 1,
        metalness: 1,
        toneMapped: 'N',
        color:
            new Color(1, 1, 1),
    },

    {
        materialName:"CeilingMat",
        aOIntensity:0.22,
        emmisiveColor:
            new Color( 0, 0, 0 ),
        emmissiveIntensity:1,
        envMapIntensity:1.3,
        lightMapIntensity:1,
        roughness:1,
        metalness:1,
        toneMapped:'N',
        color:
            new Color( 1, 1, 1 ),
    },

    {
        materialName:"SpotLightMainMat",
        aOIntensity:1.6596344379911172,
        emmisiveColor:
            new Color( 1, 1, 1 ),
        emmissiveIntensity:1,
        envMapIntensity:1.1174410659378202,
        lightMapIntensity:1.1590365562008882,
        roughness:1,
        metalness:1,
        toneMapped:'Y',
        color:
            new Color( 1, 1, 1 ),
    },
    {
        materialName:"LightBarsMat",
        aOIntensity:0.6428937478647079,
        emmisiveColor:
            new Color( 1, 1, 1 ),
        emmissiveIntensity:1,
        envMapIntensity:2.4949607106252136,
        lightMapIntensity:1,
        roughness:1,
        metalness:1,
        toneMapped:'Y',
        color:
            new Color( 1, 1, 1 ),
    },


]

/*
[
{
 materialName:"CeilingMat",
aOIntensity:0.8201176299193762,
emmisiveColor:
 new Color( 0, 0, 0 ),
emmissiveIntensity:1,
envMapIntensity:1.9881155224361051,
lightMapIntensity:1,
roughness:1,
metalness:1,
toneMapped:false,
color:
 new Color( 1, 1, 1 ),
 },

 ]

 */
